import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/app/providers/AppProviders';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { router } from '@/app/router/router';

/**
 * Root component: wraps the router in the full provider tree (Query, HeroUI,
 * Theme, Auth, UI, Toaster), inside an app-level ErrorBoundary so a render
 * failure degrades to a recoverable fallback instead of a blank page. Contains
 * no business logic.
 */
export default function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
